var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v("Electronische facturatie")]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      min: -1,
                      decimals: 0,
                      label:
                        "Maximum aantal documenten verzenden via peppol per maand",
                    },
                    model: {
                      value: _vm.maxSents,
                      callback: function ($$v) {
                        _vm.maxSents = $$v
                      },
                      expression: "maxSents",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      min: 0,
                      decimals: 0,
                      label:
                        "Aantal documenten verzonden deze maand via peppol",
                    },
                    model: {
                      value: _vm.sentCount,
                      callback: function ($$v) {
                        _vm.sentCount = $$v
                      },
                      expression: "sentCount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-date-picker", {
                    attrs: {
                      label: "Laatste document verzonden via peppol op",
                    },
                    model: {
                      value: _vm.lastSentDate,
                      callback: function ($$v) {
                        _vm.lastSentDate = $$v
                      },
                      expression: "lastSentDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      label:
                        "WinFakt gebruiken voor peppol in plaats van Billit",
                    },
                    model: {
                      value: _vm.useWfPeppol,
                      callback: function ($$v) {
                        _vm.useWfPeppol = $$v
                      },
                      expression: "useWfPeppol",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v("Annuleren")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: !_vm.isValid, icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v("Opslaan")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }